import { AbstractRouterFilter, addUrlParams } from '@zk/framework-vue';
import QueryString from 'qs';

export default class RoleAccessFilter extends AbstractRouterFilter {
  order() {
    // 在SSOFilter后执行
    return super.order() + 9;
  }

  matches(to) {
    return to.meta.projectSwitch || to.meta.userSwitch || to.meta.roles || to.meta.permissions || to.meta.rightVersion || to.meta?.notAccessFunctions?.length;
  }

  onBefore(to, from) {
    const { noAccessUrl, notAccessFunctions } = to.meta;
    //0608新增 meta.notAccessFunctions 用于判断 没有进入页面的权限（例如：如果是项目协作者则不可以进入史诗页面）
    const hasNotEnterAccess = notAccessFunctions?.length
      ? notAccessFunctions.some(fn => !!this.option.store.getters[fn])
      : false;

    const hasAccess = this.option.store.getters['user/checkAccessPermission'](to.meta);
    if (hasAccess && !hasNotEnterAccess) {
      return true;
    }
    window.console.warn(`role access denied, to: ${to.path}, noAccessUrl: ${noAccessUrl}`);
    const query = {
      ...to.query,
      from: from.path,
      fromQuery: QueryString.stringify(from.query)
    };
    if (noAccessUrl) {
      if (/[a-zA-z]+:\/\/[^\s]*/.test(noAccessUrl)) {
        window.location.href = addUrlParams(noAccessUrl, query);
        return false;
      }
      return {
        name: noAccessUrl,
        query
      };
    }
    return from.path === '/' ? '/' : '/kanban/list';
  }
}
